module.exports = __webpack_public_path__ + "static/img/7-1.aa934cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/7-1.jpg
// module id = Hm3p
// module chunks = 0